import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { PointagePause } from "./pointage-pause";

export class PointageJournalier {
    @AutoMap()
    DepartDomicile?: Temporal.PlainDateTime;
    @AutoMap()
    DebutJournee!: Temporal.PlainDateTime;
    @AutoMap()
    FinJournee!: Temporal.PlainDateTime;
    @AutoMap()
    ArriveeDomicile?: Temporal.PlainDateTime;
    @AutoMap(() => [PointagePause])
    PointagePauseList: PointagePause[] = [];

    public constructor(init?: Partial<PointageJournalier>) {
        Object.assign(this, init);
    }
}